import { React, useEffect, useState } from "react";
import ToolsTab from "../../../components/toolsTab";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import VideoBanner from "../../../components/videoBanner";
import redes_niebla from "../../../assets/images/redes_niebla.svg";
import img_murcielago from "../../../assets/images/img_murcielago.png";
import img_zorro_volador from "../../../assets/images/img_zorro_volador.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const FogNetsScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "0U8mctMTdwI";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);
  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={bosque}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit  ">
            <div className="absolute right-0 mt-24 mb-10">
              <img
              
                src={img_zorro_volador}
                className="lg:w-[45rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
          <div className="text-left h-fit col-span-2 text-black lg:mr-10 sm:bottom-0 bg-white w-full z-10 relative">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves y murciélagos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Redes de niebla
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Las redes de niebla están hechas de una malla muy fina que los animales alados no pueden detectar. En el caso de los murciélagos, se requiere de lámparas de cabeza, guantes y bolsas de algodón para depositarlos una vez capturados, además de la guía de clasificación de los murciélagos del país. Dependiendo del grupo, las redes se colocan de día o de noche.{" "}
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Es importante tomar en cuenta que el uso de esta técnica
                        debe estar supervisado por un experto en el tema, ya que
                        la separación del animal de la red, su manipulación y
                        posterior liberación requieren de habilidades precisas y
                        experiencia previa.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
                <img loading="lazy" src={redes_niebla} className=" px-20 w-full mb-40"></img>
              </div>

              <div className="relative col-span-3 2xl:mt-[15rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full 2xl:relative xl:absolute lg:absolute md:absolute sm:absolute absolute">
                    <img
                    
                      src={img_murcielago}
                      className="w-[30rem] rotate-[20deg] mb-[20rem] mt-10 -left-[7rem] relative z-0 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
                    ></img>
                  </div>
                  <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                    <ToolsTab
                    firstTitle="Sistemas productivos y naturales"
                    secondTitle="Resultados y beneficios"
                      firstTab={
                        <p className="text-xl">
                          Se recomienda colocar redes de niebla en distintos
                          tipos de hábitats como bosques primarios, secundarios,
                          áreas de cultivo y cerca de quebradas y caminos.
                        </p>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                            Los resultados pueden evidenciar el aumento de
                            riqueza de especies.
                          </p>
                          <p className="text-xl mb-5">
                            Brinda información para proteger sitios importantes
                            para la biodiversidad.
                          </p>
                          <p className="text-xl mb-5">
                            Pueden surgir nuevos atractivos turísticos y
                            especies llamativas.
                          </p>
                          <p className="text-xl mb-5">
                            Demuestra que las prácticas sostenibles o las
                            medidas de conservación implementadas por las
                            empresas tienen impacto real en las poblaciones
                            naturales.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute">
            <VideoBanner idVideo={bosque}></VideoBanner>
            <div className=" absolute left-0 lg:ml-64 md:ml-52 sm:ml-36 ml-36 mb-20 bottom-0 ">
              <img
              
                src={img_murcielago}
                className="lg:w-[20rem] md:w-[14rem] sm:w-[7rem] w-[7rem] rotate-[20deg] "
              ></img>
            </div>
            <div className=" absolute  right-0 bottom-0">
              <img
              
                src={img_zorro_volador}
                className="lg:w-[28rem] md:w-[21rem] sm:w-[12rem] w-[12rem] "
              ></img>
            </div>
          </div>
          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[30rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              
            <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves y murciélagos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Redes de niebla
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Las redes de niebla están hechas de una malla muy fina que los animales alados no pueden detectar. En el caso de los murciélagos, se requiere de lámparas de cabeza, guantes y bolsas de algodón para depositarlos una vez capturados, además de la guía de clasificación de los murciélagos del país. Dependiendo del grupo, las redes se colocan de día o de noche.{" "}
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Es importante tomar en cuenta que el uso de esta técnica
                        debe estar supervisado por un experto en el tema, ya que
                        la separación del animal de la red, su manipulación y
                        posterior liberación requieren de habilidades precisas y
                        experiencia previa.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
                <img loading="lazy" src={redes_niebla} className=" px-20 w-full mb-40"></img>
            </div>



            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Sistemas productivos y naturales"
            secondTitle="Resultados y beneficios"
                      firstTab={
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Se recomienda colocar redes de niebla en distintos
                          tipos de hábitats como bosques primarios, secundarios,
                          áreas de cultivo y cerca de quebradas y caminos.
                        </p>
                      }
                      secondTab={
                        <div>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Los resultados pueden evidenciar el aumento de
                            riqueza de especies.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Brinda información para proteger sitios importantes
                            para la biodiversidad.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Pueden surgir nuevos atractivos turísticos y
                            especies llamativas.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Demuestra que las prácticas sostenibles o las
                            medidas de conservación implementadas por las
                            empresas tienen impacto real en las poblaciones
                            naturales.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
            </div>
          </div>


        </div>
      )}
    </div>
  );
};

export default FogNetsScreen;

/*
<div className="h-32 w-full bg-orange-600 abosulte mt-[30rem]">

</div>
*/
